import { useState } from "react";
import { FaEye } from "react-icons/fa";
import { toast } from "react-toastify";
import { PropagateLoader } from "react-spinners";
import DataTable from "react-data-table-component";
import IconButton from "../../../../atoms/IconButton";
import Modal from "../../../../molecules/Modal";
import NoData from "../../../../molecules/NoData";
import useModal from "../../../../../hooks/useModal";
import { VIEW_FILE } from "../../../../../api/apiFiles";

const FacturasTable = ({ data, loading, refetch }) => {
    const [loadingView, setLoadingView] = useState();
    const [fileUrl, setFileUrl] = useState(null);
    const [selected, setSelected] = useState();
    const { open, isOpen, close } = useModal();

    const handleOpenView = async (s3Key) => {
        open();
        setSelected(s3Key);
        setLoadingView(true);
        try {
            const response = await VIEW_FILE({ s3Key });
            if (response) {
                setFileUrl(response);
            } else {
                console.error("No se pudo obtener la URL del archivo");
            }
        } catch (error) {
            console.error("Error al cargar el archivo:", error);
            toast.error("Error al cargar el archivo");
        } finally {
            setLoadingView(false);
        }
    };

    const handleClose = () => {
        close();
        setSelected(null);
        setFileUrl(null);
    };

    const columns = [
        {
            name: "Fecha de la factura",
            selector: (row) => row.date,
        },
        {
            name: "Nombre del archivo",
            selector: (row) => row.file.filename,
        },
        {
            name: "Factura",
            cell: (row) => (<IconButton icon={FaEye} bgColor="bg-rs-azul" onClick={() =>handleOpenView(row.file.s3Key)} />),
        },
    ];

    return (
        <>
            <DataTable
                data={data}
                progressPending={loading}
                columns={columns}
                progressComponent={ <div className="w-full h-20 flex justify-center items-center"> <PropagateLoader color="red" /> </div> }
                noDataComponent={<NoData />}
                pagination
            />
            {isOpen && selected &&
                <Modal title="Factura" onClose={handleClose}>
                    {loadingView ?
                        <PropagateLoader color="red" />
                        :
                        <iframe src={fileUrl} title="Factura" className="w-full h-[85vh]" />
                    }
                </Modal>
            }
        </>
    );
};

export default FacturasTable;